import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'financial_accounts',
  templateUrl: './financial_accounts.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DiscoveryFinancialAccountsComponent implements OnInit {
  @Input() data;
  @Output() dFinancialAccountsEmitter: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {}
  save() {
    this.dFinancialAccountsEmitter.emit({ status: 'forward', id: this.data.id });
  }

  back() {
    this.dFinancialAccountsEmitter.emit({ status: 'backward' });
  }
}
